var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.errorDialogVisible,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        width: "35%",
        center: ""
      },
      on: {
        "update:visible": function($event) {
          _vm.errorDialogVisible = $event
        }
      }
    },
    [
      _c("error-view", {
        attrs: { text: _vm.errorMessage, buttonTitle: _vm.errorButtonTitle },
        on: { confirm: _vm.confirm }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cdd3709", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cdd3709","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/notFound.vue
// module id = null
// module chunks = 